import { ECheckEstimationExistsActions } from '../../constants/actionTypes/checkEstimationExists';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const checkEstimationExistsRequest =
  actionGenerator<ECheckEstimationExistsActions.CHECK_ESTIMATION_EXISTS_REQUEST>(
    ECheckEstimationExistsActions.CHECK_ESTIMATION_EXISTS_REQUEST,
  );

export const checkEstimationExistsRequestError =
  actionGenerator<ECheckEstimationExistsActions.CHECK_ESTIMATION_EXISTS_ERROR>(
    ECheckEstimationExistsActions.CHECK_ESTIMATION_EXISTS_ERROR,
  );

export const resetCheckEstimationExists = actionGenerator<ECheckEstimationExistsActions.RESET_CHECK_ESTIMATION_EXISTS>(
  ECheckEstimationExistsActions.RESET_CHECK_ESTIMATION_EXISTS,
);

export interface ISetEstimationExists {
  estimationId?: number | null;
  offer?: number | null;
}
export const setEstimationReady = actionGenerator<
  ECheckEstimationExistsActions.SET_ESTIMATION_READY,
  ISetEstimationExists
>(ECheckEstimationExistsActions.SET_ESTIMATION_READY);

export type TCheckEstimationExistsActions =
  | ReturnType<typeof checkEstimationExistsRequest>
  | ReturnType<typeof checkEstimationExistsRequestError>
  | ReturnType<typeof resetCheckEstimationExists>
  | ReturnType<typeof setEstimationReady>;
